import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Grid,
  TextField,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Alert,
  Box,
} from "@mui/material";
import axios from "axios";
import BASE_URL from "../config";
const PromotePage = () => {
  const [courses, setCourses] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [classes, setClasses] = useState([]);

  const [selectedCourse, setSelectedCourse] = useState("");
  const [fromAcademicYear, setFromAcademicYear] = useState("");
  const [toAcademicYear, setToAcademicYear] = useState("");
  const [fromClass, setFromClass] = useState("");
  const [toClass, setToClass] = useState("");

  const [students, setStudents] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalStudents, setTotalStudents] = useState(0);

  const [showPromotionFields, setShowPromotionFields] = useState(false);

  const [nextAcademicYear, setNextAcademicYear] = useState(null);
  const [nextClass, setNextClass] = useState(null);
   useEffect(() => {
    fetchCourses();
  }, []);

  useEffect(() => {
    if (selectedCourse) {
      fetchAcademicYears();
      fetchClasses();
    }
  }, [selectedCourse]);

  const fetchCourses = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/coursesa`);
      setCourses(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAcademicYears = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/api/academicYears/${selectedCourse}`
      );
      setAcademicYears(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchClasses = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/api/classes?course=${selectedCourse}`
      );
      setClasses(res.data);
    } catch (error) {
      console.error(error);
    }
  };
  const handleSearch = async (currentPage = 1) => {
  try {
    if (!selectedCourse || !fromAcademicYear || !fromClass) {
      alert("Please select Course, From Academic Year and From Class");
      return;
    }

    const res = await axios.get(
      `${BASE_URL}/api/promoteStudentsList`,
      {
        params: {
          courseId: selectedCourse,
          fromAcademicYear,
          fromClass,
          page: currentPage,
        },
      }
    );

    setStudents(res.data.students);
    setTotalPages(res.data.totalPages);
    setTotalStudents(res.data.totalStudents);

    // ✅ AUTO NEXT YEAR + CLASS
    console.log(res.data.nextAcademicYear);
    setNextAcademicYear(res.data.nextAcademicYear);
    setNextClass(res.data.nextClass);

    // auto set values
    setToAcademicYear(res.data.nextAcademicYear?.AcademicYearID || "");
    setToClass(res.data.nextClass?.ClassID || "");

    setShowPromotionFields(true);
  } catch (error) {
    console.error(error);
  }
};
  useEffect(() => {
    if (page > 1) {
      handleSearch(page);
    }
  }, [page]);

  const handlePromote = async () => {
    try {
      if (!toAcademicYear || !toClass) {
        alert("Please select To Academic Year and To Class");
        return;
      }

      const confirmPromotion = window.confirm(
        `Total ${totalStudents} students will be promoted. Continue?`
      );

      if (!confirmPromotion) return;

      const adminName = sessionStorage.getItem("adminName");

      const response = await axios.post(
        `${BASE_URL}/api/promoteStudentsNew`,
        {
          courseId: selectedCourse,
          fromAcademicYear,
          fromClass,
          toAcademicYear,
          toClass,
          adminName,
        }
      );

      if (response.data.balanceStudents?.length > 0) {
        let msg = "Students having pending balance:\n\n";

        response.data.balanceStudents.forEach((s) => {
          msg += `${s.StudentName} - Balance: ₹${s.Balance}\n`;
        });

        alert(msg);
      }

      alert(response.data.message);

      handleSearch(page);
    } 
   /*  catch (error) {
      console.error(error);
      alert("Error promoting students");
    } */
   catch (error) {
  console.error(error);

  if (error.response) {
    console.log(error.response.data);

    alert(
      error.response.data.message ||
      error.response.data.error
    );
  } else {
    alert("Error promoting students");
  }
}
  };

   return (
 <Container maxWidth="xl">
      <Typography
        variant="h4"
        sx={{ textAlign: "center", fontWeight: "bold", mb: 3 }}
      >
        Promote Students
      </Typography>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Grid container spacing={2}>
           <Grid item xs={12} sm={4}>
                               <TextField
                                 select
                                 label="Course"
                                 value={selectedCourse}
                                 onChange={(e) => setSelectedCourse(e.target.value)}
                                 fullWidth
                               >
                                 {courses.map((course) => (
                                   <MenuItem key={course.CourseID} value={course.CourseID}>
                                     {course.CourseName}
                                   </MenuItem>
                                 ))}
                               </TextField>
                             </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              select
              label="From Academic Year"
              value={fromAcademicYear}
              onChange={(e) => setFromAcademicYear(e.target.value)}
              fullWidth
            >
              {academicYears.map((year) => (
                <MenuItem
                  key={year.AcademicYearID}
                  value={year.AcademicYearID}
                >
                  {year.AcademicYearName}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              select
              label="From Class"
              value={fromClass}
              onChange={(e) => setFromClass(e.target.value)}
              fullWidth
            >
              {classes.map((cls) => (
                <MenuItem key={cls.id} value={cls.id}>
                  {cls.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={3}>
            <Button
              fullWidth
              variant="contained"
              sx={{ height: "56px" }}
              onClick={() => {
                setPage(1);
                handleSearch(1);
              }}
            >
              Search
            </Button>
          </Grid>
        </Grid>
      </Paper>
      {showPromotionFields && (
  <Paper sx={{ p: 3, mb: 3 }}>
    <Grid container spacing={2}>

      {/* TO ACADEMIC YEAR */}
      <Grid item xs={12} md={4}>
        <TextField
          select
          label="To Academic Year"
          value={toAcademicYear}
          onChange={(e) => setToAcademicYear(e.target.value)}
          fullWidth
        >
          {nextAcademicYear && (
            <MenuItem
              value={nextAcademicYear.AcademicYearID}
            >
              {nextAcademicYear.AcademicYearName}
            </MenuItem>
          )}
        </TextField>
      </Grid>

      {/* TO CLASS */}
      <Grid item xs={12} md={4}>
        <TextField
          select
          label="To Class"
          value={toClass}
          onChange={(e) => setToClass(e.target.value)}
          fullWidth
        >
          {nextClass && (
            <MenuItem
              value={nextClass.ClassID}
            >
              {nextClass.ClassName}
            </MenuItem>
          )}
        </TextField>
      </Grid>

      <Grid item xs={12} md={2}>
        <Alert severity="info">
          Total Students: {totalStudents}
        </Alert>
      </Grid>

      <Grid item xs={12} md={2}>
        <Button
          variant="contained"
          color="success"
          fullWidth
          sx={{ height: "56px" }}
          onClick={handlePromote}
        >
          Promote All
        </Button>
      </Grid>

    </Grid>
  </Paper>
)}
       {students.length > 0 && (
        <>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Student ID</TableCell>
                  <TableCell>Student Name</TableCell>
                  <TableCell>Mobile Number</TableCell>
                  <TableCell>Course</TableCell>
                  <TableCell>Academic Year</TableCell>
                  <TableCell>Class</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {students.map((student) => (
                  <TableRow key={student.StudentID}>
                    <TableCell>{student.StudentID}</TableCell>
                    <TableCell>{student.StudentName}</TableCell>
                    <TableCell>{student.MobileNumber}</TableCell>
                    <TableCell>{student.CourseName}</TableCell>
                    <TableCell>{student.AcademicYearName}</TableCell>
                    <TableCell>{student.ClassName}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={(e, value) => setPage(value)}
              color="primary"
            />
          </Box>
        </>
      )}
    </Container>
  );
};

export default PromotePage;